

import React from 'react';
import Input from '../elements/Input';

const LegalDocumentsForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Document Type"
      value={formData.documentType || ''}
      onChange={e => setFormData({ ...formData, documentType: e.target.value })}
      placeholder="e.g. Last Will, Living Trust, Power of Attorney"
      error={formError.documentType}
    />
    <Input
      label="Document Holder Name"
      value={formData.holderName || ''}
      onChange={e => setFormData({ ...formData, holderName: e.target.value })}
      placeholder="e.g. John Doe, Jane Smith, Family Trust"
      error={formError.holderName}
    />
    <Input
      label="Date Signed"
      type="date"
      value={formData.dateSigned || ''}
      onChange={e => setFormData({ ...formData, dateSigned: e.target.value })}
      error={formError.dateSigned}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="e.g. Kept in locker 12, signed by 2 witnesses, notarized on 2022-05-01"
      error={formError.notes}
    />
  </>
);

export default LegalDocumentsForm;
